import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import { FIELD_LENGTHS } from 'Store/constants/sportTypes';

const validateLogin = ({ username, password }) => {
  let errors = {};

  username = !isEmpty(username) ? username : '';
  password = !isEmpty(password) ? password : '';

  // username i gerekli filtrelerden geçir.

  if (Validator.isEmpty(username)) {
    errors.username = 'required';
  }

  if (username.length < FIELD_LENGTHS.USER_ID_MIN_LENGTH) {
    errors.username = 'minLengthMembershipNumber';
  } else if (username.length !== FIELD_LENGTHS.USER_ID_MIN_LENGTH && username.length < FIELD_LENGTHS.USER_TC_NUMBER_MAX_LENGTH) {
    errors.username = 'minLengthCitizenshipNumber';
  }

  if (Validator.isEmpty(password)) {
    errors.password = 'required';
  }

  if (password.length < FIELD_LENGTHS.USER_PASSWORD_MIN_LENGTH) {
    errors.password = 'minLength';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};


export default validateLogin;
